module.exports = {
	"config": {
		"siteTitle": "TERI Senior Project",
		"baseColor": "#cc3300",
		"linkPrefix": "/~teri",
		"docPages": [
			"/docs/",
			"/docs/getting-started/",
			"/docs/how-to-run/",
			"/docs/some-react-code/",
			"/docs/the-next-step/",
			"/docs/conclusion/"
		],
		"deliverablePages": [
			"/deliverables/",
			"/deliverables/domain-model/",
			"/deliverables/project-plan/",
			"/deliverables/four-ups/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "deliverables",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "deliverables",
				"stem": "_template",
				"path": "deliverables\\_template.jsx",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\deliverables\\_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "deliverables/_template.jsx",
			"templatePath": "/deliverables/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "deliverables\\domain-model",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "deliverables/domain-model",
				"stem": "index",
				"path": "deliverables\\domain-model\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\deliverables\\domain-model\\index.md",
				"isAbsolute": false
			},
			"requirePath": "deliverables/domain-model/index.md",
			"path": "/deliverables/domain-model/",
			"data": {
				"title": "Domain Model"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "deliverables\\four-ups",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "deliverables/four-ups",
				"stem": "index",
				"path": "deliverables\\four-ups\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\deliverables\\four-ups\\index.md",
				"isAbsolute": false
			},
			"requirePath": "deliverables/four-ups/index.md",
			"path": "/deliverables/four-ups/",
			"data": {
				"title": "Four Ups"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "deliverables",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "deliverables",
				"stem": "index",
				"path": "deliverables\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\deliverables\\index.md",
				"isAbsolute": false
			},
			"requirePath": "deliverables/index.md",
			"path": "/deliverables/",
			"data": {
				"title": "Deliverables"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "deliverables\\project-plan",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "deliverables/project-plan",
				"stem": "index",
				"path": "deliverables\\project-plan\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\deliverables\\project-plan\\index.md",
				"isAbsolute": false
			},
			"requirePath": "deliverables/project-plan/index.md",
			"path": "/deliverables/project-plan/",
			"data": {
				"title": "Project Plan"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs\\_template.jsx",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\conclusion",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/conclusion",
				"stem": "index",
				"path": "docs\\conclusion\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\conclusion\\index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/conclusion/index.md",
			"path": "/docs/conclusion/",
			"data": {
				"title": "Conclusion"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\domain-model",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/domain-model",
				"stem": "index",
				"path": "docs\\domain-model\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\domain-model\\index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/domain-model/index.md",
			"path": "/docs/domain-model/",
			"data": {
				"title": "Domain Model"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\getting-started",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/getting-started",
				"stem": "index",
				"path": "docs\\getting-started\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\getting-started\\index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/getting-started/index.md",
			"path": "/docs/getting-started/",
			"data": {
				"title": "Getting Started"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\how-to-run",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/how-to-run",
				"stem": "index",
				"path": "docs\\how-to-run\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\how-to-run\\index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/how-to-run/index.md",
			"path": "/docs/how-to-run/",
			"data": {
				"title": "How to Run"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs",
				"stem": "index",
				"path": "docs\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/index.md",
			"path": "/docs/",
			"data": {
				"title": "Introduction"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\some-react-code",
				"base": "_Demo.jsx",
				"ext": "jsx",
				"name": "_Demo",
				"extname": ".jsx",
				"basename": "_Demo.jsx",
				"dirname": "docs/some-react-code",
				"stem": "_Demo",
				"path": "docs\\some-react-code\\_Demo.jsx",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\some-react-code\\_Demo.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/some-react-code/_Demo.jsx",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\some-react-code",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "docs/some-react-code",
				"stem": "index",
				"path": "docs\\some-react-code\\index.jsx",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\some-react-code\\index.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/some-react-code/index.jsx",
			"path": "/docs/some-react-code/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\the-next-step",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/the-next-step",
				"stem": "index",
				"path": "docs\\the-next-step\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\docs\\the-next-step\\index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/the-next-step/index.md",
			"path": "/docs/the-next-step/",
			"data": {
				"title": "The Next Step"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "examples",
				"stem": "index",
				"path": "examples\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\examples\\index.md",
				"isAbsolute": false
			},
			"requirePath": "examples/index.md",
			"path": "/examples/",
			"data": {
				"title": "Modules used on this site"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work-tracking",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "work-tracking",
				"stem": "index",
				"path": "work-tracking\\index.md",
				"absolute": "C:\\Users\\Ryan\\Code\\Senior Project\\website\\site\\work-tracking\\index.md",
				"isAbsolute": false
			},
			"requirePath": "work-tracking/index.md",
			"path": "/work-tracking/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 364
 ** module chunks = 0
 **/